import API from '@/api';

class Customer
{
  /**
   * Do api call to get all user currency minimum amount tiers
   *
   * @return {promise}
   */
  static async getAmountTiers() {
    return await API.dispatch(
      'GET',
      'amountTiers'
    );
  }

  /**
   * Do api call to get all user currency minimum amount tiers
   *
   * @return {promise}
   */
   static async getSubscriptions() {
    return await API.dispatch(
      'GET',
      'subscriptions'
    );
  }
}

export default Customer;